import type { CustomerDeliveryStateCode } from '@/lib/customer-state'
import { CdekShipmentDirection } from '@/lib/cdek-domain'

export const DELIVERY_STATE_META: Record<CustomerDeliveryStateCode, { label: string; tone: string }> = {
  idle: { label: 'Нет активной доставки', tone: 'bg-bone text-ink-muted border-rule' },
  preparing: { label: 'Готовится к отправке', tone: 'bg-st-processing/10 text-st-processing border-st-processing/25' },
  in_transit: { label: 'В пути', tone: 'bg-st-delivery/10 text-st-delivery border-st-delivery/25' },
  ready_for_pickup: { label: 'Ждёт в пункте', tone: 'bg-st-delivered/10 text-st-delivered border-st-delivered/25' },
  out_for_delivery: { label: 'Курьер доставляет', tone: 'bg-st-delivery/15 text-st-delivery border-st-delivery/35' },
  delivery_issue: { label: 'Проблема доставки', tone: 'bg-st-unpaid/10 text-st-unpaid border-st-unpaid/25' },
  delivered: { label: 'Доставлено', tone: 'bg-st-delivered/10 text-st-delivered border-st-delivered/25' },
  returned: { label: 'Возврат', tone: 'bg-st-pickup/10 text-st-pickup border-st-pickup/25' },
  cancelled: { label: 'Отменено', tone: 'bg-bone text-ink-muted border-rule' },
}

const RETURN_STATE_LABELS: Partial<Record<CustomerDeliveryStateCode, string>> = {
  preparing: 'Возврат оформляется',
  in_transit: 'Возврат в пути',
  ready_for_pickup: 'Возврат ждёт получения',
  out_for_delivery: 'Возврат у курьера',
  delivery_issue: 'Проблема возврата',
  delivered: 'Получен на складе',
  returned: 'Возврат не доставлен',
}

export function DeliveryStateBadge({
  state,
  count,
  direction,
}: {
  state: CustomerDeliveryStateCode
  count?: number
  direction?: CdekShipmentDirection
}) {
  const meta = DELIVERY_STATE_META[state]
  const label = direction === CdekShipmentDirection.Return
    ? RETURN_STATE_LABELS[state] || meta.label
    : meta.label
  return (
    <span className={`inline-flex px-2 py-0.5 border rounded-full text-[9px] font-medium ${meta.tone}`}>
      {label}{count && count > 1 ? ` · ${count}` : ''}
    </span>
  )
}
